var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseHair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 535.55 383.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-face-1 {\n        fill: var(--custom-color, #fa) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-face-1",
    d: "M24.63,383.77s39.81-91.66,38.81-150.66l14,51s70-31,99-114l7,56s157-25,178-92c0,0,46,105,123,103,0,0,14-35,5-67l37.18,152.67s37.82-124.67-42.18-241.67S196.44,8.11,196.44,8.11c0,0-143.15,20.33-181.58,153.16-38.42,132.84,9.77,222.49,9.77,222.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseHair);
export default __webpack_public_path__ + "static/media/base-hair.c658f6bd5e7e010dad6ec074a0ddf41b.svg";
export { ForwardRef as ReactComponent };